<template>

    <div class="user">
      <!--搜索表单-->
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-select v-model="formInline.status" placeholder="商家状态">
              <el-option label="全部" value="-1"></el-option>
              <el-option v-for="(item,index) in status" :key="index" :label="item" :value="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=""><el-input v-model="formInline.name" placeholder="商家名称"></el-input></el-form-item>
          <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        </el-form>
      </div>
      
      <!--添加商家-->
      <div class="common-level-rail">
        <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick" v-auth="'/plus/supply/supply/add'">添加商家</el-button>
      </div>
      
      <div class="product-content">
        <el-form ref="form" :model="form" label-width="100px">
          <div class="table-wrap">
            <el-table size="small"  :data="tableData" border style="width: 100%" v-loading="loading">
               <el-table-column prop="supply_id" label="商家ID"></el-table-column>
              <el-table-column prop="name" label="商家名称"></el-table-column>
              <el-table-column prop="user_id" label="关联用户ID" width="150"></el-table-column>
              <el-table-column label="账号" width="150" >
                <template slot-scope="scope">
                <span v-if="scope.row.shop_user">{{scope.row.shop_user.user_name}}</span>
              </template>	
              </el-table-column>
              <!-- <el-table-column prop="shanghui" label="所属商会"></el-table-column> -->
              <el-table-column label="商家等级">
                <template slot-scope="scope">
                <span>{{scope.row.kmd_grade.name}}</span>
              </template>	
              </el-table-column>
              <el-table-column prop="remark" label="备注" width="150"></el-table-column>
              <el-table-column prop="is_default" label="是否默认">
                  <template slot-scope="scope">
                    <el-switch
                      @change="setSupplyDefault(scope.row)"
                      v-model="scope.row.is_default"
                      active-color="#13ce66"
                      inactive-color="#c0c4cc">
                    </el-switch>
                  </template>
              </el-table-column>
              <el-table-column prop="product_num" label="商品数量"></el-table-column>
              <el-table-column prop="sort" label="排序" ></el-table-column>
              <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
              <el-table-column fixed="right" label="操作" width="90">
                <template slot-scope="scope">
  
  
  
                  <el-button v-if="scope.row.audit_status == 0" @click="editClick(scope.row)" type="text" size="small">审核</el-button>
                  
                  <!-- <el-button @click="cardClick(scope.row)" type="text" size="small">补充信息</el-button> -->
                  <!-- <el-button @click="masClick(scope.row)" type="text" size="small">工厂师傅</el-button> -->
                  <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
               
                  <!-- <el-button @click="jumpClick(scope.row)" type="text" size="small">门店</el-button> -->
                  <el-button @click="deleteClick(scope.row)" v-auth="'/plus/supply/supply/delete'" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
      <Oss :open_add="open_oss" :supply_id="supply_id" :form="obj"  v-if="open_oss"   @close="closeOss"></Oss>
      <Master :open_add="open_mas" :supply_id="supply_id" :form="obj"  v-if="open_mas"   @close="closeMas"></Master>
    </div>
  </template>
  
  <script>
  import SupplyApi from '@/api/supply.js';
  import Oss from './oss.vue';
  import Master from './master.vue';
  export default {
    components: {
      Oss,
      Master
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        formInline: {},
        status: ['禁用', '启用'],
        open_oss:false,
        supply_id:0,
        open_mas:false,
      };
    },
    created() {
  
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      cardClick(item){
        this.supply_id = item.supply_id;
        this.obj = item;
        this.open_oss = true;
      },
      closeOss(e){
        this.open_oss=false;
        this.getTableList();
      },
      masClick(item){
        this.supply_id = item.supply_id;
        this.obj = item;
        this.open_mas = true;
      },
      closeMas(e){
        this.open_mas=false;
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
  
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        SupplyApi.supplyList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            console.log(self.tableData)
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {});
      },
  
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },
  
      /*添加活动*/
      addClick() {
        this.$router.push('/plus/supply/supply/add');
      },
  
      jumpClick(e){
        this.$router.push({
            path: '/store/index',
            query: {
              supply_id: e.supply_id
            }
          });
      },
  
      /*编辑活动*/
      editClick(row) {
        let supply_id = row.supply_id;
        this.$router.push({
          path: '/plus/supply/supply/edit',
          query: {
            supply_id: supply_id
          }
        });
      },
  
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            SupplyApi.delSupply(
              {
                supply_id: row.supply_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '商家删除成功',
                    type: 'success'
                  });
                  this.onSubmit();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {});
          })
          .catch(() => {});
      },
      /* 
      *设置默认供应商
      */
      setSupplyDefault(item){
        let self = this;
        let form = {
          'supply_id':item.supply_id,
          'is_default':item.is_default,
          'operation':'setdefault',
        }
        SupplyApi.saveSupply(form, true)
        .then(data => {
          self.loading = false;
          
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
      },
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/user/supply/index.vue